import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class SessionApiManager extends BaseApiManager {
  private static instance: SessionApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): SessionApiManager {
    if (!SessionApiManager.instance) {
      SessionApiManager.instance = new SessionApiManager();
    }
    return SessionApiManager.instance;
  }

  public async fetchUserSessions(
    userId: string | number,
    page: number = 1,
    limit: number = 5,
    type: 'v' | 'b' = 'v'
  ): Promise<ApiResponse<any[]>> {
    return this.request(`/core/audio-history/SessionsHistory/${userId}/${page}/${limit}/${type}`);
  }

  public async updateLastPlayed(sessionId: number, typeSession: 'v' | 'b'): Promise<ApiResponse<any>> {
    return this.request(`/core/audio-history/UpdateLastPlayed/${sessionId}/${typeSession}`, {
      method: 'PUT'
    });
  }

  public async updateListened(sessionId: number, valor: boolean, typeSession: 'v' | 'b'): Promise<ApiResponse<any>> {
    return this.request(`/core/audio-history/UpdateListened/${sessionId}/${valor}/${typeSession}`, {
      method: 'PUT'
    });
  }

  public async deleteSession(userId: string | number, sessionId: number, typeSession: 'v' | 'b'): Promise<ApiResponse<any>> {
    return this.request(`/core/audio-history/DeleteSession/${userId}/${sessionId}/${typeSession}`, {
      method: 'DELETE',
    });
  }

  public async getUserSessions(userId: string): Promise<ApiResponse<any[]>> {
    return this.request(`/core/audio-history/users/${userId}/sessions`);
  }

  public async deleteUserSession(userId: string, sessionId: string, type: 'visualization' | 'books'): Promise<ApiResponse<any>> {
    return this.request(`/core/audio-history/users/${userId}/sessions/${sessionId}?type=${type}`, {
      method: 'DELETE',
    });
  }

  public async getSessionSummaryBySessionId(sessionId: string): Promise<ApiResponse<any>> {
    return this.request(`/core/added-user-session-inputs/session/${encodeURIComponent(sessionId)}`);
  }

  public async getAllSessionSummaries(): Promise<ApiResponse<any[]>> {
    return this.request('/core/added-user-session-inputs');
  }

  public async getSessionSummaryById(id: number): Promise<ApiResponse<any>> {
    return this.request(`/core/added-user-session-inputs/${id}`);
  }

  public async getSessionAudioHistory(sessionId: string, userId: string): Promise<ApiResponse<any>> {
    return this.request(`/core/audio-history/session/${encodeURIComponent(sessionId)}/${userId}`);
  }

  public async getSessionLimits(userId: string | number): Promise<ApiResponse<any>> {
    return this.request(`/core/chat/LimitSessions/${userId}`);
  }
}
